<template>
  <b-modal ref="editModal" v-model="modalEditOpened" :title="caption" size="lg" hide-footer id="editSprModal">
    <portal-target name="modal-dropdowns-total-spr" multiple />

    <div class="d-block">

      <InputGroupForm class="mt-1" widthPrepend="30" prepend="Федерация" v-if="visibleFields.federation">
        <FormSelectVue
            class="w-100"
            :options="federationList"
            label-key="name"
            value-key="id"
            v-model="selectedItem.federationId"
            portal-target="modal-dropdowns-total-spr">
        </FormSelectVue>
      </InputGroupForm>
      <b-form-invalid-feedback :state="validValue.federation">Не указана Федерация</b-form-invalid-feedback>

      <InputGroupForm widthPrepend="30" prepend="Код" class="mt-1" v-if="visibleFields.code">
        <b-form-input type="text" placeholder="Укажите Код" v-model="selectedItem.code"/>
      </InputGroupForm>

      <InputGroupForm widthPrepend="30" prepend="Наименование" class="mt-1" v-if="visibleFields.name">
        <b-form-input type="text" placeholder="Укажите наименование" v-model="selectedItem.name"/>
      </InputGroupForm>
      <b-form-invalid-feedback :state="validValue.name">Указано пустое Наименование</b-form-invalid-feedback>

      <InputGroupForm widthPrepend="30" prepend="Описание" class="mt-1">
        <b-form-input type="text" placeholder="Укажите описание" v-model="selectedItem.description"/>
      </InputGroupForm>

      <InputGroupForm widthPrepend="30" prepend="Тип населенного пункта" class="mt-1" size="sm" v-if="visibleFields.localityTypeName">
        <b-form-select v-model="selectedItem.localityType" :options="localityTypeList">
          <template v-slot:first>
            <option :value="null">-- Выберите Тип объекта --</option>
          </template>
        </b-form-select>
      </InputGroupForm>
      <b-form-invalid-feedback :state="validValue.federation">Не указана Федерация</b-form-invalid-feedback>

      <div class="text-right">
        <b-button class="mt-1 mr-1" variant="outline-primary" size="sm" @click="saveItem">Сохранить</b-button>
        <b-button class="mt-1" variant="outline-danger" size="sm" @click="modalEditOpened=!modalEditOpened">Отменить
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import InputGroupForm from "@/components/InputGroupForm.vue";
import FormSelectVue from "@/components/resultTeam/FormSelectVue.vue";

export default {
  components: {FormSelectVue, InputGroupForm},
  props: {
    caption: {
      type: String,
      default: 'Справочник'
    },
    visibleFields: {
      name: true,
      code: true,
      description: true,
      federation: false,
      localityTypeName: false
    },
    federationList: {
      type: Array,
      default: []
    },
    localityTypeList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      modalEditOpened: false,
      selectedItem: {
        code: null,
        name: null,
        description: null,
        federationId: null,
        localityType: null
      },
      validValue: {
        name: true,
        federation: true,
        form: true
      },
    }
  },
  methods: {
    showModal(rec) {
      this.modalEditOpened = !this.modalEditOpened
      for (var key in rec) {
        this.selectedItem[key] = rec[key];
      }
    },
    saveItem() {
      this.checkForm();
      if (this.validValue.form) {
        this.modalEditOpened = false;
        this.$emit('saveItem', this.selectedItem)
      }
    },
    checkForm() {
      for (var key in this.validValue) {
        this.validValue[key] = true;
      }
      if ((!this.selectedItem.name || this.selectedItem.name === '') && (this.visibleFields.name)) {
        this.validValue.name = false;
        this.validValue.form = false;
      }
      if ((!this.selectedItem.federationId || this.selectedItem.federationId === 0) && (this.visibleFields.federation)) {
        this.validValue.federation = false;
        this.validValue.form = false;
      }
    },
  }
}
</script>

<style scoped>

</style>
